export default __webpack_public_path__ + "assets/write-component.7b9ed9fe.svg";